"use client";

import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import { Carousel, CarouselContent, CarouselItem } from "@repo/ui/carousel";
import { cn } from "@repo/ui/utils";
import { ImageWrapper } from "@/components/common/image/image.component";
import type { ImageType } from "@/lib/types";
import type { TenantDetailData } from "../tenant-detail-data";
import { GooglePhotoSlide } from "./google-photo-slide.component";
import { PaginationRow } from "./pagination-row.component";
type GalleryImage = NonNullable<TenantDetailData["gallery"]>[number];
type GooglePhotoRef = NonNullable<TenantDetailData["googlePhotos"]>[number];
interface TenantGalleryProps {
  // Client component — pass the gallery arrays, never the whole document.
  gallery: GalleryImage[] | null;
  googlePhotos?: GooglePhotoRef[] | null;
  placeId?: string | null;
  className: string;
  testId: string;
}
export function TenantGallery(t0) {
  const $ = _c(36);
  const {
    gallery: galleryProp,
    googlePhotos: googleProp,
    placeId,
    className,
    testId
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== className || $[1] !== galleryProp || $[2] !== googleProp || $[3] !== placeId || $[4] !== testId) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const editorial = (galleryProp ?? []).filter(_temp);
      const useEditorial = editorial.length >= 2;
      const google = placeId ? (googleProp ?? []).filter(_temp2).slice(0, 2).map((photo, index) => ({
        photo,
        placeId,
        index
      })) : [];
      if (!useEditorial && google.length < 2) {
        t9 = null;
        break bb0;
      }
      if ($[16] !== className) {
        t7 = cn("bg-surface-base-primary", className);
        $[16] = className;
        $[17] = t7;
      } else {
        t7 = $[17];
      }
      t8 = testId;
      T1 = Carousel;
      t4 = "start";
      t5 = true;
      t6 = 40;
      t3 = "pl-4 desktop:pl-16";
      T0 = CarouselContent;
      t1 = "-ml-2";
      t2 = useEditorial ? editorial.map(_temp3) : google.map(_temp4);
    }
    $[0] = className;
    $[1] = galleryProp;
    $[2] = googleProp;
    $[3] = placeId;
    $[4] = testId;
    $[5] = T0;
    $[6] = T1;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    T0 = $[5];
    T1 = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[18] !== T0 || $[19] !== t1 || $[20] !== t2) {
    t10 = <T0 className={t1}>{t2}</T0>;
    $[18] = T0;
    $[19] = t1;
    $[20] = t2;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t3) {
    t11 = <div className={t3}>{t10}</div>;
    $[22] = t10;
    $[23] = t3;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <PaginationRow />;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== T1 || $[27] !== t11 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6) {
    t13 = <T1 align={t4} loop={t5} duration={t6}>{t11}{t12}</T1>;
    $[26] = T1;
    $[27] = t11;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13 || $[33] !== t7 || $[34] !== t8) {
    t14 = <section className={t7} data-testid={t8}>{t13}</section>;
    $[32] = t13;
    $[33] = t7;
    $[34] = t8;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}
function _temp4(t0) {
  const {
    photo: photo_0,
    placeId: googlePlaceId,
    index: index_0
  } = t0;
  return <CarouselItem key={photo_0.photoResourceName} className="basis-auto pl-2"><GooglePhotoSlide photo={photo_0} placeId={googlePlaceId} index={index_0} /></CarouselItem>;
}
function _temp3(image) {
  return <CarouselItem key={image.asset._id} className="basis-auto pl-2"><ImageWrapper visual={{
      image
    } as ImageType} resizeMode="cover" className="h-[240px] overflow-hidden rounded-sm tablet:h-[480px] tablet:rounded-md" imgClassName="object-cover" sizes="(max-width: 768px) 70vw, 40vw" /></CarouselItem>;
}
function _temp2(p) {
  return !!p?.photoResourceName;
}
function _temp(g) {
  return !!g?.asset?.url;
}